import { Pipe, PipeTransform } from "@angular/core";
import { Tradable } from "@modules/+new/core/tradables/domain/entities/tradable";
import { Timespan } from "@helpers/const/timespan";

@Pipe({
	name: "price_change_percent",
	standalone: false
})
export class PriceChangePercentPipe implements PipeTransform {
	public transform(newTradable: Tradable, timeframe: Timespan): number {
		return newTradable.assetPrice.pricePercentageChanges[timeframe];
	}
}
